"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeSubscriptions_en_us = void 0;
function backofficeSubscriptions_en_us() {
    return {
        "backoffice.subscription.creationtitle": "Manage Subscription",
        "backoffice.subscription.creationtext": "Subscriptions let you define a price for project features. They can be booked for projects and will be payed via companies!",
        "backoffice.subscription.selectfeatures": "Select Features",
        "backoffice.subscriptions.description": "Subscriptions extend your projects by features. You can combine as many subscriptions as you want to, all numbers will be added up",
        "backoffice.subscriptions.book": "Book",
        "backoffice.subscriptions.cancel": "Cancel",
        "backoffice.subscriptions.cancelwarntitle": "Cancel Subscription",
        "backoffice.subscriptions.cancelwarnmessage": "All already paid fees will be deducted on your next invoice and can be used for new subscriptions.",
        "backoffice.subscriptions.cancelaftertrial": "Cancel at end of current period",
        "backoffice.subscriptions.cancelnow": "Cancel now",
        "backoffice.subscriptions.continue": "Continue",
        "backoffice.subscriptions.trialperiod": "try ${days} days for free",
        "backoffice.subscriptions.setbookable": "set bookable",
        "backoffice.subscriptions.setunbookable": "set unbookable",
        "backoffice.subscriptions.bookedat": "booked at",
        "backoffice.subscriptions.cancelledat": "cancelled for",
        "backoffice.subscriptions.trialendsat": "trial until",
        "backoffice.subscriptions.errors.no_billing_email": "Your company does not have a billing e-mail set which is required for booking subscriptions. Please go to the company details and set a billing address."
    };
}
exports.backofficeSubscriptions_en_us = backofficeSubscriptions_en_us;
